const syslog: Record<string, string> = {
    title: 'Журнал',
};

export default syslog;
